import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../../../mp-core/themes/palette"
import { isSafari } from "../../../../../../mp-utils/generic-utils"

export const TOTAL_SCORE_CIRCLE_CLASSNAME = "total_score_circle"

interface StyleProps {
  subjects: string[]
}

export const useStyles = makeStyles<StyleProps>()(
  ({ palette }, { subjects = [] }) => ({
    scoring: {
      transform: isSafari() ? "rotate(180deg) scaleX(-1)" : "",
      overflow: "visible !important"
    },
    backgroundCircle: {
      fill: palette.common.white,

      ...(subjects.length > 2 && {
        stroke: blueGrey[50],
        strokeWidth: 1
      })
    },
    totalScoreCircle: {
      fill: palette.common.white,

      "&:hover": {
        fill: blueGrey[50]
      }
    }
  })
)
